var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSocialVimeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0088 3.052C19.4808 2.94 17.1008 4.928 15.8408 8.988C16.4848 8.736 17.1008 8.596 17.7168 8.596C19.0048 8.596 19.5648 9.324 19.4248 10.78C19.3408 11.648 18.7808 12.936 17.7168 14.616C16.6528 16.296 15.8688 17.136 15.3368 17.136C14.6368 17.136 14.0208 15.848 13.4608 13.244C13.2648 12.488 12.9288 10.528 12.4248 7.42C11.9768 4.536 10.7448 3.164 8.78475 3.36C7.94475 3.444 6.71275 4.2 5.03275 5.656C3.80075 6.72 2.56875 7.84 1.30875 8.932L2.51275 10.472C3.66075 9.66 4.33275 9.268 4.50075 9.268C5.36875 9.268 6.18075 10.64 6.93675 13.384C7.60875 15.904 8.30875 18.424 8.98075 20.944C9.98875 23.688 11.2488 25.06 12.7328 25.06C15.1128 25.06 18.0528 22.82 21.4968 18.312C24.8568 14 26.5928 10.612 26.7048 8.148C26.8728 4.816 25.6408 3.136 23.0088 3.052Z",
    fill: "#476A89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialVimeo);
export default __webpack_public_path__ + "static/media/icon-social-vimeo.e27166254c37e9ac48246405026e64d2.svg";
export { ForwardRef as ReactComponent };